import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="buttons"
      x="0"
      y="0"
      enableBackground="new 0 0 300 300"
      version="1.1"
      viewBox="0 0 300 300"
      xmlSpace="preserve"
    >
      <g id="menu-idle">
        <linearGradient
          id="SVGID_1_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle cx="150" cy="150" r="149.5" className="st0"></circle>
        <linearGradient
          id="SVGID_00000116226359840237526520000000179438496660384644_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000116226359840237526520000000179438496660384644_)"
        ></circle>
        <path
          d="M207.1 186H96.5c-7.6 0-13.8 5.7-13.8 12.8s6.2 12.8 13.8 12.8h110.6c7.6 0 13.8-5.7 13.8-12.8 0-7-6.2-12.8-13.8-12.8zM207.1 136.4H96.5c-7.6 0-13.8 5.7-13.8 12.8S88.9 162 96.5 162h110.6c7.6 0 13.8-5.7 13.8-12.8s-6.2-12.8-13.8-12.8zM96.5 111.5h110.6c7.6 0 13.8-5.7 13.8-12.8 0-7.1-6.2-12.8-13.8-12.8H96.5c-7.6 0-13.8 5.7-13.8 12.8 0 7 6.2 12.8 13.8 12.8z"
          className="st2"
        ></path>
      </g>
      <g id="menu-hover">
        <linearGradient
          id="SVGID_00000146476186011236654000000003658719693232639409_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000146476186011236654000000003658719693232639409_)"
        ></circle>
        <linearGradient
          id="SVGID_00000108278263237840854380000004456551372638770870_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#4F4F4F"></stop>
          <stop offset="0.126" stopColor="#454545"></stop>
          <stop offset="0.703" stopColor="#1C1C1C"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000108278263237840854380000004456551372638770870_)"
        ></circle>
        <path
          d="M207.1 186H96.5c-7.6 0-13.8 5.7-13.8 12.8s6.2 12.8 13.8 12.8h110.6c7.6 0 13.8-5.7 13.8-12.8 0-7-6.2-12.8-13.8-12.8zM207.1 136.4H96.5c-7.6 0-13.8 5.7-13.8 12.8S88.9 162 96.5 162h110.6c7.6 0 13.8-5.7 13.8-12.8s-6.2-12.8-13.8-12.8zM96.5 111.5h110.6c7.6 0 13.8-5.7 13.8-12.8 0-7.1-6.2-12.8-13.8-12.8H96.5c-7.6 0-13.8 5.7-13.8 12.8 0 7 6.2 12.8 13.8 12.8z"
          className="st5"
        ></path>
      </g>
      <g id="menu-clicked">
        <linearGradient
          id="SVGID_00000138545965056948957030000003266523519202236068_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000138545965056948957030000003266523519202236068_)"
        ></circle>
        <linearGradient
          id="SVGID_00000150082856931812873120000004162924030715145142_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000150082856931812873120000004162924030715145142_)"
        ></circle>
        <path
          d="M207.1 186H96.5c-7.6 0-13.8 5.7-13.8 12.8s6.2 12.8 13.8 12.8h110.6c7.6 0 13.8-5.7 13.8-12.8 0-7-6.2-12.8-13.8-12.8zM207.1 136.4H96.5c-7.6 0-13.8 5.7-13.8 12.8S88.9 162 96.5 162h110.6c7.6 0 13.8-5.7 13.8-12.8s-6.2-12.8-13.8-12.8zM96.5 111.5h110.6c7.6 0 13.8-5.7 13.8-12.8 0-7.1-6.2-12.8-13.8-12.8H96.5c-7.6 0-13.8 5.7-13.8 12.8 0 7 6.2 12.8 13.8 12.8z"
          className="st2"
        ></path>
      </g>
      <g id="menu-selected-idle">
        <linearGradient
          id="SVGID_00000008847141719401202030000012940911379239846055_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000008847141719401202030000012940911379239846055_)"
        ></circle>
        <linearGradient
          id="SVGID_00000142862614279317663130000003223259430001399217_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000142862614279317663130000003223259430001399217_)"
        ></circle>
        <path
          d="M207.1 186H96.5c-7.6 0-13.8 5.7-13.8 12.8s6.2 12.8 13.8 12.8h110.6c7.6 0 13.8-5.7 13.8-12.8 0-7-6.2-12.8-13.8-12.8zM207.1 136.4H96.5c-7.6 0-13.8 5.7-13.8 12.8S88.9 162 96.5 162h110.6c7.6 0 13.8-5.7 13.8-12.8s-6.2-12.8-13.8-12.8zM96.5 111.5h110.6c7.6 0 13.8-5.7 13.8-12.8 0-7.1-6.2-12.8-13.8-12.8H96.5c-7.6 0-13.8 5.7-13.8 12.8 0 7 6.2 12.8 13.8 12.8z"
          className="st10"
        ></path>
      </g>
      <g id="menu-selected-hover">
        <linearGradient
          id="SVGID_00000172421121525415636020000011338591012822139285_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000172421121525415636020000011338591012822139285_)"
        ></circle>
        <linearGradient
          id="SVGID_00000044165388810368306010000004393159029499626643_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000044165388810368306010000004393159029499626643_)"
        ></circle>
        <path
          d="M207.1 186H96.5c-7.6 0-13.8 5.7-13.8 12.8s6.2 12.8 13.8 12.8h110.6c7.6 0 13.8-5.7 13.8-12.8 0-7-6.2-12.8-13.8-12.8zM207.1 136.4H96.5c-7.6 0-13.8 5.7-13.8 12.8S88.9 162 96.5 162h110.6c7.6 0 13.8-5.7 13.8-12.8s-6.2-12.8-13.8-12.8zM96.5 111.5h110.6c7.6 0 13.8-5.7 13.8-12.8 0-7.1-6.2-12.8-13.8-12.8H96.5c-7.6 0-13.8 5.7-13.8 12.8 0 7 6.2 12.8 13.8 12.8z"
          className="st13"
        ></path>
      </g>
      <g id="menu-selected-clicked">
        <linearGradient
          id="SVGID_00000152255258701209924020000010372891839203325095_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000152255258701209924020000010372891839203325095_)"
        ></circle>
        <linearGradient
          id="SVGID_00000031889198883569600020000010147472637361805440_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000031889198883569600020000010147472637361805440_)"
        ></circle>
        <path
          d="M207.1 186H96.5c-7.6 0-13.8 5.7-13.8 12.8s6.2 12.8 13.8 12.8h110.6c7.6 0 13.8-5.7 13.8-12.8 0-7-6.2-12.8-13.8-12.8zM207.1 136.4H96.5c-7.6 0-13.8 5.7-13.8 12.8S88.9 162 96.5 162h110.6c7.6 0 13.8-5.7 13.8-12.8s-6.2-12.8-13.8-12.8zM96.5 111.5h110.6c7.6 0 13.8-5.7 13.8-12.8 0-7.1-6.2-12.8-13.8-12.8H96.5c-7.6 0-13.8 5.7-13.8 12.8 0 7 6.2 12.8 13.8 12.8z"
          className="st13"
        ></path>
      </g>
      <g id="autoplay-idle">
        <linearGradient
          id="SVGID_00000011023336853007367610000008509480389117816464_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000011023336853007367610000008509480389117816464_)"
        ></circle>
        <linearGradient
          id="SVGID_00000150102909755169416720000002769280224021590440_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000150102909755169416720000002769280224021590440_)"
        ></circle>
        <path
          d="M137.6 203.6c-2.8 0-5.6-.6-8.3-1.8-5.9-2.8-9.6-8.3-9.6-14.4v-76.7c0-6.1 3.7-11.6 9.6-14.4 6.7-3.1 14.6-2.2 20.2 2.4l46.6 38.3c3.7 3.1 5.9 7.5 5.9 12.1s-2.1 9-5.9 12.1l-46.6 38.3c-3.3 2.7-7.6 4.1-11.9 4.1z"
          className="st2"
        ></path>
      </g>
      <g id="autoplay-hover">
        <linearGradient
          id="SVGID_00000018213337839189229550000016771805139270529942_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000018213337839189229550000016771805139270529942_)"
        ></circle>
        <linearGradient
          id="SVGID_00000139284810608708023030000001989269851145743755_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#4F4F4F"></stop>
          <stop offset="0.126" stopColor="#454545"></stop>
          <stop offset="0.703" stopColor="#1C1C1C"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000139284810608708023030000001989269851145743755_)"
        ></circle>
        <path
          d="M137.6 203.6c-2.8 0-5.6-.6-8.3-1.8-5.9-2.8-9.6-8.3-9.6-14.4v-76.7c0-6.1 3.7-11.6 9.6-14.4 6.7-3.1 14.6-2.2 20.2 2.4l46.6 38.3c3.7 3.1 5.9 7.5 5.9 12.1s-2.1 9-5.9 12.1l-46.6 38.3c-3.3 2.7-7.6 4.1-11.9 4.1z"
          className="st5"
        ></path>
      </g>
      <g id="autoplay-clicked">
        <linearGradient
          id="SVGID_00000045620631490523826130000002029473355145065617_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000045620631490523826130000002029473355145065617_)"
        ></circle>
        <linearGradient
          id="SVGID_00000083807757998165192490000010305448417522274707_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000083807757998165192490000010305448417522274707_)"
        ></circle>
        <path
          d="M137.6 203.6c-2.8 0-5.6-.6-8.3-1.8-5.9-2.8-9.6-8.3-9.6-14.4v-76.7c0-6.1 3.7-11.6 9.6-14.4 6.7-3.1 14.6-2.2 20.2 2.4l46.6 38.3c3.7 3.1 5.9 7.5 5.9 12.1s-2.1 9-5.9 12.1l-46.6 38.3c-3.3 2.7-7.6 4.1-11.9 4.1z"
          className="st2"
        ></path>
      </g>
      <g id="autoplay-disabled-idle">
        <linearGradient
          id="SVGID_00000071534170136371627820000011184496904485957788_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000071534170136371627820000011184496904485957788_)"
        ></circle>
        <linearGradient
          id="SVGID_00000180339407303611711230000012312139055221892015_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000180339407303611711230000012312139055221892015_)"
        ></circle>
        <path
          d="M137.6 203.6c-2.8 0-5.6-.6-8.3-1.8-5.9-2.8-9.6-8.3-9.6-14.4v-76.7c0-6.1 3.7-11.6 9.6-14.4 6.7-3.1 14.6-2.2 20.2 2.4l46.6 38.3c3.7 3.1 5.9 7.5 5.9 12.1s-2.1 9-5.9 12.1l-46.6 38.3c-3.3 2.7-7.6 4.1-11.9 4.1z"
          className="st24"
        ></path>
      </g>
      <g id="autoplay-selected-idle">
        <linearGradient
          id="SVGID_00000070111666244494599070000013258883312030864814_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000070111666244494599070000013258883312030864814_)"
        ></circle>
        <linearGradient
          id="SVGID_00000183208027007391559490000008336924915934435716_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000183208027007391559490000008336924915934435716_)"
        ></circle>
        <path
          d="M137.6 203.6c-2.8 0-5.6-.6-8.3-1.8-5.9-2.8-9.6-8.3-9.6-14.4v-76.7c0-6.1 3.7-11.6 9.6-14.4 6.7-3.1 14.6-2.2 20.2 2.4l46.6 38.3c3.7 3.1 5.9 7.5 5.9 12.1s-2.1 9-5.9 12.1l-46.6 38.3c-3.3 2.7-7.6 4.1-11.9 4.1z"
          className="st10"
        ></path>
      </g>
      <g id="autoplay-selected-hover">
        <linearGradient
          id="SVGID_00000103240082198592176450000002882828836460192695_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000103240082198592176450000002882828836460192695_)"
        ></circle>
        <linearGradient
          id="SVGID_00000014617490120877639580000010213388442812014267_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000014617490120877639580000010213388442812014267_)"
        ></circle>
        <path
          d="M137.6 203.6c-2.8 0-5.6-.6-8.3-1.8-5.9-2.8-9.6-8.3-9.6-14.4v-76.7c0-6.1 3.7-11.6 9.6-14.4 6.7-3.1 14.6-2.2 20.2 2.4l46.6 38.3c3.7 3.1 5.9 7.5 5.9 12.1s-2.1 9-5.9 12.1l-46.6 38.3c-3.3 2.7-7.6 4.1-11.9 4.1z"
          className="st13"
        ></path>
      </g>
      <g id="autoplay-selected-clicked">
        <linearGradient
          id="SVGID_00000010994900800757522300000014869185312442093980_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000010994900800757522300000014869185312442093980_)"
        ></circle>
        <linearGradient
          id="SVGID_00000141429435808520665030000004863544020575436937_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000141429435808520665030000004863544020575436937_)"
        ></circle>
        <path
          d="M137.6 203.6c-2.8 0-5.6-.6-8.3-1.8-5.9-2.8-9.6-8.3-9.6-14.4v-76.7c0-6.1 3.7-11.6 9.6-14.4 6.7-3.1 14.6-2.2 20.2 2.4l46.6 38.3c3.7 3.1 5.9 7.5 5.9 12.1s-2.1 9-5.9 12.1l-46.6 38.3c-3.3 2.7-7.6 4.1-11.9 4.1z"
          className="st13"
        ></path>
      </g>
      <g id="autoplay-active-idle">
        <linearGradient
          id="SVGID_00000069382004836092828140000000827352261574707120_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000069382004836092828140000000827352261574707120_)"
        ></circle>
        <linearGradient
          id="SVGID_00000122714229636071467410000003676487840902690720_"
          x1="1.131"
          x2="309.812"
          y1="151.046"
          y2="151.046"
          gradientTransform="rotate(-91.208 150.333 151.333) scale(1.00002)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="149"
          r="140.5"
          fill="url(#SVGID_00000122714229636071467410000003676487840902690720_)"
        ></circle>
        <path
          d="M168.2 274.6h-32.8c-1.8 0-3.3-1.5-3.3-3.3v-32.6c0-1.8 1.5-3.3 3.3-3.3h32.7c1.8 0 3.3 1.5 3.3 3.3v32.6c.1 1.8-1.4 3.3-3.2 3.3z"
          className="st33"
        ></path>
        <path
          d="M165.7 271.6h-27.8c-1.5 0-2.8-1.2-2.8-2.8v-27.7c0-1.5 1.2-2.8 2.8-2.8h27.8c1.5 0 2.8 1.2 2.8 2.8v27.6c0 1.7-1.3 2.9-2.8 2.9z"
          className="st34"
        ></path>
      </g>
      <g id="autoplay-active-hover">
        <linearGradient
          id="SVGID_00000098899817633831147950000009053795502068516490_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000098899817633831147950000009053795502068516490_)"
        ></circle>
        <linearGradient
          id="SVGID_00000029004285401703749230000010987617089884267199_"
          x1="1.131"
          x2="309.812"
          y1="151.046"
          y2="151.046"
          gradientTransform="rotate(-91.208 150.333 151.333) scale(1.00002)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#4F4F4F"></stop>
          <stop offset="0.126" stopColor="#454545"></stop>
          <stop offset="0.703" stopColor="#1C1C1C"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="149"
          r="140.5"
          fill="url(#SVGID_00000029004285401703749230000010987617089884267199_)"
        ></circle>
      </g>
      <g id="autoplay-active-clicked">
        <linearGradient
          id="SVGID_00000057836260269820692980000010414980555096377225_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000057836260269820692980000010414980555096377225_)"
        ></circle>
        <linearGradient
          id="SVGID_00000170979726419862126250000008438963503484216476_"
          x1="1.131"
          x2="309.812"
          y1="151.046"
          y2="151.046"
          gradientTransform="rotate(-91.208 150.333 151.333) scale(1.00002)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="149"
          r="140.5"
          fill="url(#SVGID_00000170979726419862126250000008438963503484216476_)"
        ></circle>
      </g>
      <g id="quickspin-idle">
        <linearGradient
          id="SVGID_00000003813987703031882880000015056622124015249569_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000003813987703031882880000015056622124015249569_)"
        ></circle>
        <linearGradient
          id="SVGID_00000170988256768706390720000017044024575896604346_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000170988256768706390720000017044024575896604346_)"
        ></circle>
        <path
          d="M224.3 139.9l-42.5-35.1c-5.1-4.2-12.3-5-18.4-2.2-5.4 2.6-8.7 7.6-8.7 13.2v21.6l-39.5-32.7c-5.1-4.2-12.3-5-18.4-2.2-5.4 2.6-8.7 7.6-8.7 13.2v70.2c0 5.6 3.4 10.7 8.7 13.2 2.4 1.1 5 1.7 7.6 1.7 3.9 0 7.8-1.3 10.9-3.9l39.5-32.6v21.6c0 5.6 3.4 10.7 8.7 13.2 2.4 1.1 5 1.7 7.6 1.7 3.9 0 7.8-1.3 10.9-3.9l42.5-35.1c3.4-2.8 5.4-6.8 5.4-11.1-.2-4-2.2-8-5.6-10.8z"
          className="st2"
        ></path>
      </g>
      <g id="quickspin-hover">
        <linearGradient
          id="SVGID_00000183927904248102184230000002490926975354323079_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000183927904248102184230000002490926975354323079_)"
        ></circle>
        <linearGradient
          id="SVGID_00000098219641710042067350000017425778441929478552_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#4F4F4F"></stop>
          <stop offset="0.126" stopColor="#454545"></stop>
          <stop offset="0.703" stopColor="#1C1C1C"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000098219641710042067350000017425778441929478552_)"
        ></circle>
        <path
          d="M224.3 139.9l-42.5-35.1c-5.1-4.2-12.3-5-18.4-2.2-5.4 2.6-8.7 7.6-8.7 13.2v21.6l-39.5-32.7c-5.1-4.2-12.3-5-18.4-2.2-5.4 2.6-8.7 7.6-8.7 13.2v70.2c0 5.6 3.4 10.7 8.7 13.2 2.4 1.1 5 1.7 7.6 1.7 3.9 0 7.8-1.3 10.9-3.9l39.5-32.6v21.6c0 5.6 3.4 10.7 8.7 13.2 2.4 1.1 5 1.7 7.6 1.7 3.9 0 7.8-1.3 10.9-3.9l42.5-35.1c3.4-2.8 5.4-6.8 5.4-11.1-.2-4-2.2-8-5.6-10.8z"
          className="st5"
        ></path>
      </g>
      <g id="quickspin-clicked">
        <linearGradient
          id="SVGID_00000117647918646527776510000005884246878542593460_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000117647918646527776510000005884246878542593460_)"
        ></circle>
        <linearGradient
          id="SVGID_00000119108289471742927960000012781997489995402155_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.081" stopColor="#393939"></stop>
          <stop offset="0.24" stopColor="#252525"></stop>
          <stop offset="0.42" stopColor="#171717"></stop>
          <stop offset="0.639" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000119108289471742927960000012781997489995402155_)"
        ></circle>
        <path
          d="M224.3 139.9l-42.5-35.1c-5.1-4.2-12.3-5-18.4-2.2-5.4 2.6-8.7 7.6-8.7 13.2v21.6l-39.5-32.7c-5.1-4.2-12.3-5-18.4-2.2-5.4 2.6-8.7 7.6-8.7 13.2v70.2c0 5.6 3.4 10.7 8.7 13.2 2.4 1.1 5 1.7 7.6 1.7 3.9 0 7.8-1.3 10.9-3.9l39.5-32.6v21.6c0 5.6 3.4 10.7 8.7 13.2 2.4 1.1 5 1.7 7.6 1.7 3.9 0 7.8-1.3 10.9-3.9l42.5-35.1c3.4-2.8 5.4-6.8 5.4-11.1-.2-4-2.2-8-5.6-10.8z"
          className="st2"
        ></path>
      </g>
      <g id="quickspin-selected-idle">
        <linearGradient
          id="SVGID_00000009573139416134259050000005408361347176292520_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000009573139416134259050000005408361347176292520_)"
        ></circle>
        <linearGradient
          id="SVGID_00000181796966683850340380000006898772684859356349_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000181796966683850340380000006898772684859356349_)"
        ></circle>
        <path
          d="M224.3 139.9l-42.5-35.1c-5.1-4.2-12.3-5-18.4-2.2-5.4 2.6-8.7 7.6-8.7 13.2v21.6l-39.5-32.7c-5.1-4.2-12.3-5-18.4-2.2-5.4 2.6-8.7 7.6-8.7 13.2v70.2c0 5.6 3.4 10.7 8.7 13.2 2.4 1.1 5 1.7 7.6 1.7 3.9 0 7.8-1.3 10.9-3.9l39.5-32.6v21.6c0 5.6 3.4 10.7 8.7 13.2 2.4 1.1 5 1.7 7.6 1.7 3.9 0 7.8-1.3 10.9-3.9l42.5-35.1c3.4-2.8 5.4-6.8 5.4-11.1-.2-4-2.2-8-5.6-10.8z"
          className="st10"
        ></path>
      </g>
      <g id="quickspin-selected-hover">
        <linearGradient
          id="SVGID_00000003811625488322237390000006323006985041719208_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000003811625488322237390000006323006985041719208_)"
        ></circle>
        <linearGradient
          id="SVGID_00000129170057928953898510000002057322502904193202_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000129170057928953898510000002057322502904193202_)"
        ></circle>
        <path
          d="M224.3 139.9l-42.5-35.1c-5.1-4.2-12.3-5-18.4-2.2-5.4 2.6-8.7 7.6-8.7 13.2v21.6l-39.5-32.7c-5.1-4.2-12.3-5-18.4-2.2-5.4 2.6-8.7 7.6-8.7 13.2v70.2c0 5.6 3.4 10.7 8.7 13.2 2.4 1.1 5 1.7 7.6 1.7 3.9 0 7.8-1.3 10.9-3.9l39.5-32.6v21.6c0 5.6 3.4 10.7 8.7 13.2 2.4 1.1 5 1.7 7.6 1.7 3.9 0 7.8-1.3 10.9-3.9l42.5-35.1c3.4-2.8 5.4-6.8 5.4-11.1-.2-4-2.2-8-5.6-10.8z"
          className="st13"
        ></path>
      </g>
      <g id="quickspin-selected-clicked">
        <linearGradient
          id="SVGID_00000171000773860815819530000018066828944081713543_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000171000773860815819530000018066828944081713543_)"
        ></circle>
        <linearGradient
          id="SVGID_00000146463710377757699450000002958324598907018370_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000146463710377757699450000002958324598907018370_)"
        ></circle>
        <path
          d="M224.3 139.9l-42.5-35.1c-5.1-4.2-12.3-5-18.4-2.2-5.4 2.6-8.7 7.6-8.7 13.2v21.6l-39.5-32.7c-5.1-4.2-12.3-5-18.4-2.2-5.4 2.6-8.7 7.6-8.7 13.2v70.2c0 5.6 3.4 10.7 8.7 13.2 2.4 1.1 5 1.7 7.6 1.7 3.9 0 7.8-1.3 10.9-3.9l39.5-32.6v21.6c0 5.6 3.4 10.7 8.7 13.2 2.4 1.1 5 1.7 7.6 1.7 3.9 0 7.8-1.3 10.9-3.9l42.5-35.1c3.4-2.8 5.4-6.8 5.4-11.1-.2-4-2.2-8-5.6-10.8z"
          className="st13"
        ></path>
      </g>
      <g id="spin-idle">
        <linearGradient
          id="SVGID_00000181799135849629777440000014720590060512769206_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000181799135849629777440000014720590060512769206_)"
        ></circle>
        <linearGradient
          id="SVGID_00000124848499124968057910000015254381609238761354_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#383838"></stop>
          <stop offset="0.097" stopColor="#2A2A2A"></stop>
          <stop offset="0.24" stopColor="#1F1F1F"></stop>
          <stop offset="0.441" stopColor="#181818"></stop>
          <stop offset="1" stopColor="#161616"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000124848499124968057910000015254381609238761354_)"
        ></circle>
        <path
          d="M152.8 216.1c-36.3 0-65.7-29.4-65.7-65.5s29.5-65.5 65.7-65.5c2.4 0 4.8.1 7.3.4V74.9c0-1.4.8-2.6 2.1-3.1s2.7-.2 3.7.8l23.3 23.3c1.3 1.3 1.3 3.4 0 4.8L165.9 124c-1 1-2.4 1.3-3.7.7-1.2-.5-2.1-1.8-2.1-3.1v-11.7c-2.4-.4-4.8-.6-7.3-.6-23 0-41.7 18.6-41.7 41.5s18.7 41.5 41.7 41.5 41.6-18.6 41.6-41.5c0-1.9 1.5-3.4 3.4-3.4h17.3c1.9 0 3.4 1.5 3.4 3.4.1 35.9-29.4 65.3-65.7 65.3z"
          className="st2"
        ></path>
      </g>
      <g id="spin-disabled-idle">
        <linearGradient
          id="SVGID_00000038401869530315957980000014904630898834326674_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000038401869530315957980000014904630898834326674_)"
        ></circle>
        <linearGradient
          id="SVGID_00000106115479162288505870000008916842053128991900_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#383838"></stop>
          <stop offset="0.097" stopColor="#2A2A2A"></stop>
          <stop offset="0.24" stopColor="#1F1F1F"></stop>
          <stop offset="0.441" stopColor="#181818"></stop>
          <stop offset="1" stopColor="#161616"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000106115479162288505870000008916842053128991900_)"
        ></circle>
        <path
          d="M152.8 216.1c-36.3 0-65.7-29.4-65.7-65.5s29.5-65.5 65.7-65.5c2.4 0 4.8.1 7.3.4V74.9c0-1.4.8-2.6 2.1-3.1s2.7-.2 3.7.8l23.3 23.3c1.3 1.3 1.3 3.4 0 4.8L165.9 124c-1 1-2.4 1.3-3.7.7-1.2-.5-2.1-1.8-2.1-3.1v-11.7c-2.4-.4-4.8-.6-7.3-.6-23 0-41.7 18.6-41.7 41.5s18.7 41.5 41.7 41.5 41.6-18.6 41.6-41.5c0-1.9 1.5-3.4 3.4-3.4h17.3c1.9 0 3.4 1.5 3.4 3.4.1 35.9-29.4 65.3-65.7 65.3z"
          className="st55"
        ></path>
      </g>
      <g id="spin-hover">
        <linearGradient
          id="SVGID_00000125602270496803737320000015749963802772179584_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000125602270496803737320000015749963802772179584_)"
        ></circle>
        <linearGradient
          id="SVGID_00000043451304230566980340000000334249563520215741_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#383838"></stop>
          <stop offset="0.099" stopColor="#2E2E2E"></stop>
          <stop offset="0.293" stopColor="#202020"></stop>
          <stop offset="0.538" stopColor="#181818"></stop>
          <stop offset="1" stopColor="#161616"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000043451304230566980340000000334249563520215741_)"
        ></circle>
        <path
          d="M152.8 216.1c-36.3 0-65.7-29.4-65.7-65.5s29.5-65.5 65.7-65.5c2.4 0 4.8.1 7.3.4V74.9c0-1.4.8-2.6 2.1-3.1s2.7-.2 3.7.8l23.3 23.3c1.3 1.3 1.3 3.4 0 4.8L165.9 124c-1 1-2.4 1.3-3.7.7-1.2-.5-2.1-1.8-2.1-3.1v-11.7c-2.4-.4-4.8-.6-7.3-.6-23 0-41.7 18.6-41.7 41.5s18.7 41.5 41.7 41.5 41.6-18.6 41.6-41.5c0-1.9 1.5-3.4 3.4-3.4h17.3c1.9 0 3.4 1.5 3.4 3.4.1 35.9-29.4 65.3-65.7 65.3z"
          className="st10"
        ></path>
      </g>
      <g id="spin-clicked">
        <linearGradient
          id="SVGID_00000061429794360346677040000000402385343561295258_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000061429794360346677040000000402385343561295258_)"
        ></circle>
        <linearGradient
          id="SVGID_00000110429808284055488520000009219118795433952395_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000110429808284055488520000009219118795433952395_)"
        ></circle>
        <path
          d="M152.8 216.1c-36.3 0-65.7-29.4-65.7-65.5s29.5-65.5 65.7-65.5c2.4 0 4.8.1 7.3.4V74.9c0-1.4.8-2.6 2.1-3.1s2.7-.2 3.7.8l23.3 23.3c1.3 1.3 1.3 3.4 0 4.8L165.9 124c-1 1-2.4 1.3-3.7.7-1.2-.5-2.1-1.8-2.1-3.1v-11.7c-2.4-.4-4.8-.6-7.3-.6-23 0-41.7 18.6-41.7 41.5s18.7 41.5 41.7 41.5 41.6-18.6 41.6-41.5c0-1.9 1.5-3.4 3.4-3.4h17.3c1.9 0 3.4 1.5 3.4 3.4.1 35.9-29.4 65.3-65.7 65.3z"
          className="st10"
        ></path>
      </g>
      <g id="skip-idle">
        <linearGradient
          id="SVGID_00000083769291068020149490000001943449129099842954_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000083769291068020149490000001943449129099842954_)"
        ></circle>
        <linearGradient
          id="SVGID_00000041289847075319303210000014610425594309445537_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#383838"></stop>
          <stop offset="0.097" stopColor="#2A2A2A"></stop>
          <stop offset="0.24" stopColor="#1F1F1F"></stop>
          <stop offset="0.441" stopColor="#181818"></stop>
          <stop offset="1" stopColor="#161616"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000041289847075319303210000014610425594309445537_)"
        ></circle>
        <path
          d="M203.3 209.1H102.7c-5.5 0-10-4.5-10-10V98.9c0-5.5 4.5-10 10-10h100.5c5.5 0 10 4.5 10 10V199c.1 5.6-4.4 10.1-9.9 10.1z"
          className="st10"
        ></path>
      </g>
      <g id="skip-hover">
        <linearGradient
          id="SVGID_00000015347674794956192520000010408711572407358874_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000015347674794956192520000010408711572407358874_)"
        ></circle>
        <linearGradient
          id="SVGID_00000037669980380480213750000007324659842535563920_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#383838"></stop>
          <stop offset="0.097" stopColor="#2A2A2A"></stop>
          <stop offset="0.24" stopColor="#1F1F1F"></stop>
          <stop offset="0.441" stopColor="#181818"></stop>
          <stop offset="1" stopColor="#161616"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000037669980380480213750000007324659842535563920_)"
        ></circle>
        <path
          d="M203.3 209.1H102.7c-5.5 0-10-4.5-10-10V98.9c0-5.5 4.5-10 10-10h100.5c5.5 0 10 4.5 10 10V199c.1 5.6-4.4 10.1-9.9 10.1z"
          className="st13"
        ></path>
      </g>
      <g id="skip-clicked">
        <linearGradient
          id="SVGID_00000034057483786098114910000011663896523589898641_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000034057483786098114910000011663896523589898641_)"
        ></circle>
        <linearGradient
          id="SVGID_00000099642637491204232550000016853150567706773894_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000099642637491204232550000016853150567706773894_)"
        ></circle>
        <path
          d="M203.3 209.1H102.7c-5.5 0-10-4.5-10-10V98.9c0-5.5 4.5-10 10-10h100.5c5.5 0 10 4.5 10 10V199c.1 5.6-4.4 10.1-9.9 10.1z"
          className="st13"
        ></path>
      </g>
      <g id="skip-disabled-idle">
        <linearGradient
          id="SVGID_00000085932778529396523710000016556071200791431325_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000085932778529396523710000016556071200791431325_)"
        ></circle>
        <linearGradient
          id="SVGID_00000001640844069111983600000011741642049138121661_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#383838"></stop>
          <stop offset="0.097" stopColor="#2A2A2A"></stop>
          <stop offset="0.24" stopColor="#1F1F1F"></stop>
          <stop offset="0.441" stopColor="#181818"></stop>
          <stop offset="1" stopColor="#161616"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000001640844069111983600000011741642049138121661_)"
        ></circle>
        <path
          d="M203.3 209.1H102.7c-5.5 0-10-4.5-10-10V98.9c0-5.5 4.5-10 10-10h100.5c5.5 0 10 4.5 10 10V199c.1 5.6-4.4 10.1-9.9 10.1z"
          className="st55"
        ></path>
      </g>
      <g id="start-autoplay-idle">
        <linearGradient
          id="SVGID_00000122705224010088524710000000712240586361104060_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000122705224010088524710000000712240586361104060_)"
        ></circle>
        <linearGradient
          id="SVGID_00000146468886656529739560000004876134321511517833_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#383838"></stop>
          <stop offset="0.097" stopColor="#2A2A2A"></stop>
          <stop offset="0.24" stopColor="#1F1F1F"></stop>
          <stop offset="0.441" stopColor="#181818"></stop>
          <stop offset="1" stopColor="#161616"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000146468886656529739560000004876134321511517833_)"
        ></circle>
        <path
          d="M133.9 212.2c-3.2 0-6.5-.7-9.6-2.1-6.8-3.2-11.1-9.6-11.1-16.7v-88.8c0-7.1 4.3-13.4 11.1-16.7 7.8-3.6 16.9-2.5 23.4 2.8l53.9 44.3c4.3 3.6 6.8 8.7 6.8 14s-2.4 10.4-6.8 14l-53.9 44.3c-3.8 3.3-8.8 4.9-13.8 4.9z"
          className="st10"
        ></path>
      </g>
      <g id="start-autoplay-hover">
        <linearGradient
          id="SVGID_00000020380980778803002740000017653959922704733367_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000020380980778803002740000017653959922704733367_)"
        ></circle>
        <linearGradient
          id="SVGID_00000028302221005188321510000004340055639004821126_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#383838"></stop>
          <stop offset="0.099" stopColor="#2E2E2E"></stop>
          <stop offset="0.293" stopColor="#202020"></stop>
          <stop offset="0.538" stopColor="#181818"></stop>
          <stop offset="1" stopColor="#161616"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000028302221005188321510000004340055639004821126_)"
        ></circle>
        <path
          d="M133.9 212.2c-3.2 0-6.5-.7-9.6-2.1-6.8-3.2-11.1-9.6-11.1-16.7v-88.8c0-7.1 4.3-13.4 11.1-16.7 7.8-3.6 16.9-2.5 23.4 2.8l53.9 44.3c4.3 3.6 6.8 8.7 6.8 14s-2.4 10.4-6.8 14l-53.9 44.3c-3.8 3.3-8.8 4.9-13.8 4.9z"
          className="st13"
        ></path>
      </g>
      <g id="start-autoplay-clicked">
        <linearGradient
          id="SVGID_00000172416347448181585540000009963192052331477917_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000172416347448181585540000009963192052331477917_)"
        ></circle>
        <linearGradient
          id="SVGID_00000100380491808716035310000009819784769040737159_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000100380491808716035310000009819784769040737159_)"
        ></circle>
        <path
          d="M133.9 212.2c-3.2 0-6.5-.7-9.6-2.1-6.8-3.2-11.1-9.6-11.1-16.7v-88.8c0-7.1 4.3-13.4 11.1-16.7 7.8-3.6 16.9-2.5 23.4 2.8l53.9 44.3c4.3 3.6 6.8 8.7 6.8 14s-2.4 10.4-6.8 14l-53.9 44.3c-3.8 3.3-8.8 4.9-13.8 4.9z"
          className="st13"
        ></path>
      </g>
      <g id="bet-idle">
        <linearGradient
          id="SVGID_00000031167864198056493210000013887309021614398622_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000031167864198056493210000013887309021614398622_)"
        ></circle>
        <linearGradient
          id="SVGID_00000175308415982177533940000012148475180477852809_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000175308415982177533940000012148475180477852809_)"
        ></circle>
        <path
          d="M134.7 81.4c-22.8 0-39.9 9.7-39.9 22.8s17.1 22.8 39.9 22.8 39.9-9.7 39.9-22.8-17.1-22.8-39.9-22.8z"
          className="st2"
        ></path>
        <path
          d="M134.7 138.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12z"
          className="st2"
        ></path>
        <path
          d="M134.7 167c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8V155c-9.1 7.4-23.4 12-39.9 12z"
          className="st2"
        ></path>
        <path
          d="M134.7 195.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12zM191.7 178.4H186v17.1h5.7c22.8 0 39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.3 12-39.9 12zM191.7 121.3H186V167h5.7c22.8 0 39.9-9.7 39.9-22.8s-17.1-22.9-39.9-22.9z"
          className="st2"
        ></path>
      </g>
      <g id="bet-hover">
        <linearGradient
          id="SVGID_00000000199587195343011620000016015376301048427703_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000000199587195343011620000016015376301048427703_)"
        ></circle>
        <linearGradient
          id="SVGID_00000142857695061529523720000010243682218664359832_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#4F4F4F"></stop>
          <stop offset="0.126" stopColor="#454545"></stop>
          <stop offset="0.703" stopColor="#1C1C1C"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000142857695061529523720000010243682218664359832_)"
        ></circle>
        <path
          d="M134.7 81.4c-22.8 0-39.9 9.7-39.9 22.8s17.1 22.8 39.9 22.8 39.9-9.7 39.9-22.8-17.1-22.8-39.9-22.8z"
          className="st5"
        ></path>
        <path
          d="M134.7 138.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12z"
          className="st5"
        ></path>
        <path
          d="M134.7 167c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8V155c-9.1 7.4-23.4 12-39.9 12z"
          className="st5"
        ></path>
        <path
          d="M134.7 195.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12zM191.7 178.4H186v17.1h5.7c22.8 0 39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.3 12-39.9 12zM191.7 121.3H186V167h5.7c22.8 0 39.9-9.7 39.9-22.8s-17.1-22.9-39.9-22.9z"
          className="st5"
        ></path>
      </g>
      <g id="bet-clicked">
        <linearGradient
          id="SVGID_00000106105136081501013060000017995175845401769100_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000106105136081501013060000017995175845401769100_)"
        ></circle>
        <linearGradient
          id="SVGID_00000001654386135290553990000015372690631378298289_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000001654386135290553990000015372690631378298289_)"
        ></circle>
        <path
          d="M134.7 81.4c-22.8 0-39.9 9.7-39.9 22.8s17.1 22.8 39.9 22.8 39.9-9.7 39.9-22.8-17.1-22.8-39.9-22.8z"
          className="st2"
        ></path>
        <path
          d="M134.7 138.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12z"
          className="st2"
        ></path>
        <path
          d="M134.7 167c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8V155c-9.1 7.4-23.4 12-39.9 12z"
          className="st2"
        ></path>
        <path
          d="M134.7 195.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12zM191.7 178.4H186v17.1h5.7c22.8 0 39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.3 12-39.9 12zM191.7 121.3H186V167h5.7c22.8 0 39.9-9.7 39.9-22.8s-17.1-22.9-39.9-22.9z"
          className="st2"
        ></path>
      </g>
      <g id="bet-selected-idle">
        <linearGradient
          id="SVGID_00000106858256256344196370000001066946398188240816_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000106858256256344196370000001066946398188240816_)"
        ></circle>
        <linearGradient
          id="SVGID_00000111178584082929963040000000191788995521684896_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000111178584082929963040000000191788995521684896_)"
        ></circle>
        <path
          d="M134.7 81.4c-22.8 0-39.9 9.7-39.9 22.8s17.1 22.8 39.9 22.8 39.9-9.7 39.9-22.8-17.1-22.8-39.9-22.8z"
          className="st10"
        ></path>
        <path
          d="M134.7 138.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12z"
          className="st10"
        ></path>
        <path
          d="M134.7 167c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8V155c-9.1 7.4-23.4 12-39.9 12z"
          className="st10"
        ></path>
        <path
          d="M134.7 195.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12zM191.7 178.4H186v17.1h5.7c22.8 0 39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.3 12-39.9 12zM191.7 121.3H186V167h5.7c22.8 0 39.9-9.7 39.9-22.8s-17.1-22.9-39.9-22.9z"
          className="st10"
        ></path>
      </g>
      <g id="bet-selected-hover">
        <linearGradient
          id="SVGID_00000042727928308393170490000009089568560358550678_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000042727928308393170490000009089568560358550678_)"
        ></circle>
        <linearGradient
          id="SVGID_00000173141878538137562810000005437369221848860850_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000173141878538137562810000005437369221848860850_)"
        ></circle>
        <path
          d="M134.7 81.4c-22.8 0-39.9 9.7-39.9 22.8s17.1 22.8 39.9 22.8 39.9-9.7 39.9-22.8-17.1-22.8-39.9-22.8z"
          className="st13"
        ></path>
        <path
          d="M134.7 138.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12z"
          className="st13"
        ></path>
        <path
          d="M134.7 167c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8V155c-9.1 7.4-23.4 12-39.9 12z"
          className="st13"
        ></path>
        <path
          d="M134.7 195.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12zM191.7 178.4H186v17.1h5.7c22.8 0 39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.3 12-39.9 12zM191.7 121.3H186V167h5.7c22.8 0 39.9-9.7 39.9-22.8s-17.1-22.9-39.9-22.9z"
          className="st13"
        ></path>
      </g>
      <g id="bet-selected-clicked">
        <linearGradient
          id="SVGID_00000011017992641487954720000013583520523246289067_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000011017992641487954720000013583520523246289067_)"
        ></circle>
        <linearGradient
          id="SVGID_00000076590007420946210720000003135761864873781159_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000076590007420946210720000003135761864873781159_)"
        ></circle>
        <path
          d="M134.7 81.4c-22.8 0-39.9 9.7-39.9 22.8s17.1 22.8 39.9 22.8 39.9-9.7 39.9-22.8-17.1-22.8-39.9-22.8z"
          className="st13"
        ></path>
        <path
          d="M134.7 138.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12z"
          className="st13"
        ></path>
        <path
          d="M134.7 167c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8V155c-9.1 7.4-23.4 12-39.9 12z"
          className="st13"
        ></path>
        <path
          d="M134.7 195.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12zM191.7 178.4H186v17.1h5.7c22.8 0 39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.3 12-39.9 12zM191.7 121.3H186V167h5.7c22.8 0 39.9-9.7 39.9-22.8s-17.1-22.9-39.9-22.9z"
          className="st13"
        ></path>
      </g>
      <g id="bet-disabled-idle">
        <linearGradient
          id="SVGID_00000126308655434794889510000009825933779195054753_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000126308655434794889510000009825933779195054753_)"
        ></circle>
        <linearGradient
          id="SVGID_00000060006053609700094940000018004972907242556585_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#383838"></stop>
          <stop offset="0.097" stopColor="#2A2A2A"></stop>
          <stop offset="0.24" stopColor="#1F1F1F"></stop>
          <stop offset="0.441" stopColor="#181818"></stop>
          <stop offset="1" stopColor="#161616"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000060006053609700094940000018004972907242556585_)"
        ></circle>
        <path
          d="M134.7 81.4c-22.8 0-39.9 9.7-39.9 22.8s17.1 22.8 39.9 22.8 39.9-9.7 39.9-22.8-17.1-22.8-39.9-22.8z"
          className="st24"
        ></path>
        <path
          d="M134.7 138.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12z"
          className="st24"
        ></path>
        <path
          d="M134.7 167c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8V155c-9.1 7.4-23.4 12-39.9 12z"
          className="st24"
        ></path>
        <path
          d="M134.7 195.5c-16.5 0-30.8-4.6-39.9-12v6.3c0 13.1 17.1 22.8 39.9 22.8s39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.4 12-39.9 12zM191.7 178.4H186v17.1h5.7c22.8 0 39.9-9.7 39.9-22.8v-6.3c-9.1 7.4-23.3 12-39.9 12zM191.7 121.3H186V167h5.7c22.8 0 39.9-9.7 39.9-22.8s-17.1-22.9-39.9-22.9z"
          className="st24"
        ></path>
      </g>
      <g id="minus-idle">
        <linearGradient
          id="SVGID_00000179608979189123898960000009019523749629541822_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000179608979189123898960000009019523749629541822_)"
        ></circle>
        <linearGradient
          id="SVGID_00000076582134186008195690000011857620938075489932_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000076582134186008195690000011857620938075489932_)"
        ></circle>
        <path
          d="M212.7 136.3h-118c-8.2 0-14.8 6.2-14.8 13.7 0 7.6 6.6 13.7 14.8 13.7h118c8.1 0 14.8-6.2 14.8-13.7-.1-7.6-6.7-13.7-14.8-13.7z"
          className="st2"
        ></path>
      </g>
      <g id="minus-hover">
        <linearGradient
          id="SVGID_00000106828420019744556780000010220110473259207321_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000106828420019744556780000010220110473259207321_)"
        ></circle>
        <linearGradient
          id="SVGID_00000137824932340730176250000002900381400496033720_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#4F4F4F"></stop>
          <stop offset="0.126" stopColor="#454545"></stop>
          <stop offset="0.703" stopColor="#1C1C1C"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000137824932340730176250000002900381400496033720_)"
        ></circle>
        <path
          d="M212.7 136.3h-118c-8.2 0-14.8 6.2-14.8 13.7 0 7.6 6.6 13.7 14.8 13.7h118c8.1 0 14.8-6.2 14.8-13.7-.1-7.6-6.7-13.7-14.8-13.7z"
          className="st5"
        ></path>
      </g>
      <g id="minus-clicked">
        <linearGradient
          id="SVGID_00000172421000980692682550000006281160577207059107_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000172421000980692682550000006281160577207059107_)"
        ></circle>
        <linearGradient
          id="SVGID_00000166648376811963139550000016740322553173790879_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000166648376811963139550000016740322553173790879_)"
        ></circle>
        <path
          d="M212.7 136.3h-118c-8.2 0-14.8 6.2-14.8 13.7 0 7.6 6.6 13.7 14.8 13.7h118c8.1 0 14.8-6.2 14.8-13.7-.1-7.6-6.7-13.7-14.8-13.7z"
          className="st94"
        ></path>
      </g>
      <g id="plus-idle">
        <linearGradient
          id="SVGID_00000022559954293431917000000015058915020417577344_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000022559954293431917000000015058915020417577344_)"
        ></circle>
        <linearGradient
          id="SVGID_00000096042465075639105140000005876245295935617157_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.109" stopColor="#3D3D3D"></stop>
          <stop offset="0.456" stopColor="#222"></stop>
          <stop offset="0.764" stopColor="#121212"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000096042465075639105140000005876245295935617157_)"
        ></circle>
        <path
          d="M227.4 150c0 7.6-6.6 13.7-14.8 13.7h-45.3V209c0 8.2-6.1 14.8-13.7 14.8s-13.7-6.6-13.7-14.8v-45.3H94.6c-8.1 0-14.8-6.2-14.8-13.7 0-7.6 6.6-13.7 14.8-13.7h45.3V91c0-8.2 6.2-14.8 13.7-14.8 7.6 0 13.7 6.6 13.7 14.8v45.3h45.3c8.2 0 14.8 6.1 14.8 13.7z"
          className="st2"
        ></path>
      </g>
      <g id="plus-hover">
        <linearGradient
          id="SVGID_00000043417675089522202850000009083515299439104911_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000043417675089522202850000009083515299439104911_)"
        ></circle>
        <linearGradient
          id="SVGID_00000051384422308624692150000002469434865771938182_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#4F4F4F"></stop>
          <stop offset="0.126" stopColor="#454545"></stop>
          <stop offset="0.703" stopColor="#1C1C1C"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000051384422308624692150000002469434865771938182_)"
        ></circle>
        <path
          d="M227.4 150c0 7.6-6.6 13.7-14.8 13.7h-45.3V209c0 8.2-6.1 14.8-13.7 14.8s-13.7-6.6-13.7-14.8v-45.3H94.6c-8.1 0-14.8-6.2-14.8-13.7 0-7.6 6.6-13.7 14.8-13.7h45.3V91c0-8.2 6.2-14.8 13.7-14.8 7.6 0 13.7 6.6 13.7 14.8v45.3h45.3c8.2 0 14.8 6.1 14.8 13.7z"
          className="st5"
        ></path>
      </g>
      <g id="plus-clicked">
        <linearGradient
          id="SVGID_00000114055097866254376450000006647127497312740762_"
          x1="-11.178"
          x2="317.284"
          y1="149.305"
          y2="149.305"
          gradientTransform="scale(-1 1) rotate(84.742 -.364 -14.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.162" stopColor="#474747"></stop>
          <stop offset="0.462" stopColor="#383838"></stop>
          <stop offset="1" stopColor="#141414"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="149.5"
          fill="url(#SVGID_00000114055097866254376450000006647127497312740762_)"
        ></circle>
        <linearGradient
          id="SVGID_00000176044868566807582840000002909979848517067707_"
          x1="0.172"
          x2="308.853"
          y1="148.975"
          y2="148.975"
          gradientTransform="matrix(-.02109 -.9998 -.9998 .02109 302.144 298.498)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#474747"></stop>
          <stop offset="0.075" stopColor="#3B3B3B"></stop>
          <stop offset="0.243" stopColor="#262626"></stop>
          <stop offset="0.431" stopColor="#171717"></stop>
          <stop offset="0.654" stopColor="#0F0F0F"></stop>
          <stop offset="1" stopColor="#0C0C0C"></stop>
        </linearGradient>
        <circle
          cx="150"
          cy="150"
          r="140.5"
          fill="url(#SVGID_00000176044868566807582840000002909979848517067707_)"
        ></circle>
        <path
          d="M227.4 150c0 7.6-6.6 13.7-14.8 13.7h-45.3V209c0 8.2-6.1 14.8-13.7 14.8s-13.7-6.6-13.7-14.8v-45.3H94.6c-8.1 0-14.8-6.2-14.8-13.7 0-7.6 6.6-13.7 14.8-13.7h45.3V91c0-8.2 6.2-14.8 13.7-14.8 7.6 0 13.7 6.6 13.7 14.8v45.3h45.3c8.2 0 14.8 6.1 14.8 13.7z"
          className="st94"
        ></path>
      </g>
      <path
        id="close-idle"
        d="M220.2 196.8c5.7 5.7 5.7 15 0 20.7l-2.6 2.7c-5.7 5.7-15 5.7-20.7 0L150 173.4l-46.8 46.8c-5.7 5.7-15 5.7-20.7 0l-2.6-2.7c-5.7-5.7-5.7-15 0-20.7l46.8-46.8-46.8-46.9c-5.7-5.7-5.7-15 0-20.7l2.6-2.6c5.7-5.7 15-5.7 20.7 0l46.8 46.8 46.8-46.8c5.7-5.7 15-5.7 20.7 0l2.6 2.6c5.7 5.7 5.7 15 0 20.7L173.4 150l46.8 46.8z"
        className="st2"
      ></path>
      <path
        id="close-hover"
        d="M220.2 196.8c5.7 5.7 5.7 15 0 20.7l-2.6 2.7c-5.7 5.7-15 5.7-20.7 0L150 173.4l-46.8 46.8c-5.7 5.7-15 5.7-20.7 0l-2.6-2.7c-5.7-5.7-5.7-15 0-20.7l46.8-46.8-46.8-46.9c-5.7-5.7-5.7-15 0-20.7l2.6-2.6c5.7-5.7 15-5.7 20.7 0l46.8 46.8 46.8-46.8c5.7-5.7 15-5.7 20.7 0l2.6 2.6c5.7 5.7 5.7 15 0 20.7L173.4 150l46.8 46.8z"
        className="st5"
      ></path>
      <g id="home-idle">
        <path
          id="home-idle-path"
          d="M131.6 217.4v-46h36.8v46c0 5.1 4.1 9.2 9.2 9.2h27.6c5.1 0 9.2-4.1 9.2-9.2V153H230c4.2 0 6.3-5.2 3-8l-76.9-69.3c-3.5-3.1-8.8-3.1-12.3 0L66.9 145c-3.1 2.8-1.2 8 3 8h15.6v64.4c0 5.1 4.1 9.2 9.2 9.2h27.6c5.1 0 9.3-4.1 9.3-9.2z"
          className="st101"
        ></path>
      </g>
      <g id="home-hover">
        <path
          id="home-hover-path"
          d="M131.6 217.4v-46h36.8v46c0 5.1 4.1 9.2 9.2 9.2h27.6c5.1 0 9.2-4.1 9.2-9.2V153H230c4.2 0 6.3-5.2 3-8l-76.9-69.3c-3.5-3.1-8.8-3.1-12.3 0L66.9 145c-3.1 2.8-1.2 8 3 8h15.6v64.4c0 5.1 4.1 9.2 9.2 9.2h27.6c5.1 0 9.3-4.1 9.3-9.2z"
          className="st102"
        ></path>
      </g>
      <path
        id="info-idle"
        d="M189.5 224.2l-2.7 10.8c-8 3.1-14.3 5.5-19 7.2-4.7 1.6-10.2 2.5-16.5 2.5-9.6 0-17.1-2.4-22.5-7-5.3-4.7-8-10.6-8-17.8 0-2.8.2-5.7.6-8.6.4-2.9 1.1-6.2 1.9-9.9l9.9-35.1c.9-3.4 1.6-6.5 2.2-9.6.6-3 .9-5.7.9-8.2 0-4.5-.9-7.6-2.8-9.4-1.9-1.8-5.4-2.6-10.6-2.6-2.6 0-5.2.4-7.9 1.2-2.7.8-5 1.6-7 2.3l2.7-10.8c6.5-2.6 12.7-4.9 18.7-6.8s11.6-2.8 16.9-2.8c9.6 0 16.9 2.3 22.1 6.9 5.2 4.6 7.8 10.6 7.8 18 0 1.5-.2 4.2-.5 8-.4 3.8-1 7.4-2 10.6l-9.9 34.9c-.8 2.8-1.5 6-2.2 9.6s-1 6.3-1 8.2c0 4.6 1 7.8 3.1 9.5s5.7 2.5 10.8 2.5c2.4 0 5.1-.4 8.2-1.3 3.2-1 5.4-1.7 6.8-2.3zM192 77.5c0 6.1-2.3 11.3-6.9 15.6-4.6 4.3-10.2 6.4-16.7 6.4s-12.1-2.1-16.8-6.4-7-9.5-7-15.6 2.3-11.3 7-15.6 10.2-6.5 16.8-6.5c6.5 0 12.1 2.2 16.7 6.5s6.9 9.5 6.9 15.6z"
        className="st2"
      ></path>
      <path
        id="info-hover"
        d="M189.5 224.2l-2.7 10.8c-8 3.1-14.3 5.5-19 7.2-4.7 1.6-10.2 2.5-16.5 2.5-9.6 0-17.1-2.4-22.5-7-5.3-4.7-8-10.6-8-17.8 0-2.8.2-5.7.6-8.6.4-2.9 1.1-6.2 1.9-9.9l9.9-35.1c.9-3.4 1.6-6.5 2.2-9.6.6-3 .9-5.7.9-8.2 0-4.5-.9-7.6-2.8-9.4-1.9-1.8-5.4-2.6-10.6-2.6-2.6 0-5.2.4-7.9 1.2-2.7.8-5 1.6-7 2.3l2.7-10.8c6.5-2.6 12.7-4.9 18.7-6.8s11.6-2.8 16.9-2.8c9.6 0 16.9 2.3 22.1 6.9 5.2 4.6 7.8 10.6 7.8 18 0 1.5-.2 4.2-.5 8-.4 3.8-1 7.4-2 10.6l-9.9 34.9c-.8 2.8-1.5 6-2.2 9.6s-1 6.3-1 8.2c0 4.6 1 7.8 3.1 9.5s5.7 2.5 10.8 2.5c2.4 0 5.1-.4 8.2-1.3 3.2-1 5.4-1.7 6.8-2.3zM192 77.5c0 6.1-2.3 11.3-6.9 15.6-4.6 4.3-10.2 6.4-16.7 6.4s-12.1-2.1-16.8-6.4-7-9.5-7-15.6 2.3-11.3 7-15.6 10.2-6.5 16.8-6.5c6.5 0 12.1 2.2 16.7 6.5s6.9 9.5 6.9 15.6z"
        className="st5"
      ></path>
      <path
        id="info-selected-idle"
        d="M189.5 224.2l-2.7 10.8c-8 3.1-14.3 5.5-19 7.2-4.7 1.6-10.2 2.5-16.5 2.5-9.6 0-17.1-2.4-22.5-7-5.3-4.7-8-10.6-8-17.8 0-2.8.2-5.7.6-8.6.4-2.9 1.1-6.2 1.9-9.9l9.9-35.1c.9-3.4 1.6-6.5 2.2-9.6.6-3 .9-5.7.9-8.2 0-4.5-.9-7.6-2.8-9.4-1.9-1.8-5.4-2.6-10.6-2.6-2.6 0-5.2.4-7.9 1.2-2.7.8-5 1.6-7 2.3l2.7-10.8c6.5-2.6 12.7-4.9 18.7-6.8s11.6-2.8 16.9-2.8c9.6 0 16.9 2.3 22.1 6.9 5.2 4.6 7.8 10.6 7.8 18 0 1.5-.2 4.2-.5 8-.4 3.8-1 7.4-2 10.6l-9.9 34.9c-.8 2.8-1.5 6-2.2 9.6s-1 6.3-1 8.2c0 4.6 1 7.8 3.1 9.5s5.7 2.5 10.8 2.5c2.4 0 5.1-.4 8.2-1.3 3.2-1 5.4-1.7 6.8-2.3zM192 77.5c0 6.1-2.3 11.3-6.9 15.6-4.6 4.3-10.2 6.4-16.7 6.4s-12.1-2.1-16.8-6.4-7-9.5-7-15.6 2.3-11.3 7-15.6 10.2-6.5 16.8-6.5c6.5 0 12.1 2.2 16.7 6.5s6.9 9.5 6.9 15.6z"
        className="st10"
      ></path>
      <path
        id="settings-idle"
        d="M247.4 142.2c0-6.6-5.1-12-11.7-12.4l-6.4-.4c-4.8-.3-8.9-3.3-10.7-7.7 0 0 0-.1-.1-.1-1.8-4.4-1-9.4 2.2-13l4.2-4.8c4.4-4.9 4.1-12.4-.5-17L213.5 76c-4.7-4.6-12.1-4.9-17.1-.5l-4.8 4.2c-3.6 3.1-8.6 4-13 2.2 0 0-.1 0-.1-.1-4.4-1.8-7.4-6-7.7-10.7l-.4-6.4c-.4-6.6-5.9-11.6-12.5-11.6h-15.4c-6.6 0-12 5.1-12.5 11.6l-.4 6.5c-.3 4.7-3.3 8.9-7.7 10.7-.1 0-.1 0-.2.1-4.4 1.8-9.4 1-13-2.2l-4.8-4.2c-4.9-4.3-12.4-4.1-17.1.5l-11 10.7c-4.7 4.6-4.9 12.1-.6 17l4.2 4.8c3.1 3.6 4 8.6 2.1 13 0 .1 0 .1-.1.2-1.8 4.4-6 7.4-10.7 7.7l-6.4.4c-6.6.4-11.7 5.9-11.7 12.4v15.4c0 6.6 5.1 12 11.7 12.4l6.5.4c4.8.3 8.9 3.3 10.7 7.7 0 0 0 .1.1.1 1.8 4.4 1 9.4-2.2 13l-4.2 4.8c-4.4 4.9-4.1 12.4.5 17L86.6 224c4.7 4.7 12.1 4.9 17.1.5l4.8-4.2c3.6-3.1 8.6-4 13-2.2 0 0 .1 0 .1.1 4.4 1.8 7.4 6 7.7 10.7l.4 6.4c.4 6.6 5.9 11.6 12.5 11.6h15.4c6.6 0 12-5.1 12.5-11.6l.4-6.4c.3-4.7 3.3-8.9 7.7-10.7 0 0 .1 0 .1-.1 4.4-1.8 9.5-1 13 2.2l4.8 4.2c5 4.3 12.4 4.1 17.1-.5l10.9-10.9c4.7-4.6 4.9-12.1.5-17l-4.2-4.8c-3.1-3.6-4-8.6-2.2-13 0 0 0-.1.1-.1 1.8-4.4 6-7.4 10.7-7.7l6.4-.4c6.6-.4 11.7-5.9 11.7-12.4l.3-15.5zm-96.7 38.1c-17.4 0-31.5-14.1-31.5-31.4s14.1-31.4 31.5-31.4 31.5 14.1 31.5 31.4-14.1 31.4-31.5 31.4z"
        className="st2"
      ></path>
      <path
        id="settings-hover"
        d="M247.4 142.2c0-6.6-5.1-12-11.7-12.4l-6.4-.4c-4.8-.3-8.9-3.3-10.7-7.7 0 0 0-.1-.1-.1-1.8-4.4-1-9.4 2.2-13l4.2-4.8c4.4-4.9 4.1-12.4-.5-17L213.5 76c-4.7-4.6-12.1-4.9-17.1-.5l-4.8 4.2c-3.6 3.1-8.6 4-13 2.2 0 0-.1 0-.1-.1-4.4-1.8-7.4-6-7.7-10.7l-.4-6.4c-.4-6.6-5.9-11.6-12.5-11.6h-15.4c-6.6 0-12 5.1-12.5 11.6l-.4 6.5c-.3 4.7-3.3 8.9-7.7 10.7-.1 0-.1 0-.2.1-4.4 1.8-9.4 1-13-2.2l-4.8-4.2c-4.9-4.3-12.4-4.1-17.1.5l-11 10.7c-4.7 4.6-4.9 12.1-.6 17l4.2 4.8c3.1 3.6 4 8.6 2.1 13 0 .1 0 .1-.1.2-1.8 4.4-6 7.4-10.7 7.7l-6.4.4c-6.6.4-11.7 5.9-11.7 12.4v15.4c0 6.6 5.1 12 11.7 12.4l6.5.4c4.8.3 8.9 3.3 10.7 7.7 0 0 0 .1.1.1 1.8 4.4 1 9.4-2.2 13l-4.2 4.8c-4.4 4.9-4.1 12.4.5 17L86.6 224c4.7 4.7 12.1 4.9 17.1.5l4.8-4.2c3.6-3.1 8.6-4 13-2.2 0 0 .1 0 .1.1 4.4 1.8 7.4 6 7.7 10.7l.4 6.4c.4 6.6 5.9 11.6 12.5 11.6h15.4c6.6 0 12-5.1 12.5-11.6l.4-6.4c.3-4.7 3.3-8.9 7.7-10.7 0 0 .1 0 .1-.1 4.4-1.8 9.5-1 13 2.2l4.8 4.2c5 4.3 12.4 4.1 17.1-.5l10.9-10.9c4.7-4.6 4.9-12.1.5-17l-4.2-4.8c-3.1-3.6-4-8.6-2.2-13 0 0 0-.1.1-.1 1.8-4.4 6-7.4 10.7-7.7l6.4-.4c6.6-.4 11.7-5.9 11.7-12.4l.3-15.5zm-96.7 38.1c-17.4 0-31.5-14.1-31.5-31.4s14.1-31.4 31.5-31.4 31.5 14.1 31.5 31.4-14.1 31.4-31.5 31.4z"
        className="st5"
      ></path>
      <path
        id="settings-selected-idle"
        d="M247.4 142.2c0-6.6-5.1-12-11.7-12.4l-6.4-.4c-4.8-.3-8.9-3.3-10.7-7.7 0 0 0-.1-.1-.1-1.8-4.4-1-9.4 2.2-13l4.2-4.8c4.4-4.9 4.1-12.4-.5-17L213.5 76c-4.7-4.6-12.1-4.9-17.1-.5l-4.8 4.2c-3.6 3.1-8.6 4-13 2.2 0 0-.1 0-.1-.1-4.4-1.8-7.4-6-7.7-10.7l-.4-6.4c-.4-6.6-5.9-11.6-12.5-11.6h-15.4c-6.6 0-12 5.1-12.5 11.6l-.4 6.5c-.3 4.7-3.3 8.9-7.7 10.7-.1 0-.1 0-.2.1-4.4 1.8-9.4 1-13-2.2l-4.8-4.2c-4.9-4.3-12.4-4.1-17.1.5l-11 10.7c-4.7 4.6-4.9 12.1-.6 17l4.2 4.8c3.1 3.6 4 8.6 2.1 13 0 .1 0 .1-.1.2-1.8 4.4-6 7.4-10.7 7.7l-6.4.4c-6.6.4-11.7 5.9-11.7 12.4v15.4c0 6.6 5.1 12 11.7 12.4l6.5.4c4.8.3 8.9 3.3 10.7 7.7 0 0 0 .1.1.1 1.8 4.4 1 9.4-2.2 13l-4.2 4.8c-4.4 4.9-4.1 12.4.5 17L86.6 224c4.7 4.7 12.1 4.9 17.1.5l4.8-4.2c3.6-3.1 8.6-4 13-2.2 0 0 .1 0 .1.1 4.4 1.8 7.4 6 7.7 10.7l.4 6.4c.4 6.6 5.9 11.6 12.5 11.6h15.4c6.6 0 12-5.1 12.5-11.6l.4-6.4c.3-4.7 3.3-8.9 7.7-10.7 0 0 .1 0 .1-.1 4.4-1.8 9.5-1 13 2.2l4.8 4.2c5 4.3 12.4 4.1 17.1-.5l10.9-10.9c4.7-4.6 4.9-12.1.5-17l-4.2-4.8c-3.1-3.6-4-8.6-2.2-13 0 0 0-.1.1-.1 1.8-4.4 6-7.4 10.7-7.7l6.4-.4c6.6-.4 11.7-5.9 11.7-12.4l.3-15.5zm-96.7 38.1c-17.4 0-31.5-14.1-31.5-31.4s14.1-31.4 31.5-31.4 31.5 14.1 31.5 31.4-14.1 31.4-31.5 31.4z"
        className="st10"
      ></path>
      <path
        id="sound-on-idle"
        d="M161.7 78.2c2.5-1.7 5.7-1.9 8.4-.5s4.3 4.2 4.3 7.2v130.3c0 3-1.7 5.8-4.3 7.2-1.2.6-2.5.9-3.8.9-1.6 0-3.2-.5-4.6-1.4l-52.2-35.8h-41c-4.5 0-8.1-3.6-8.1-8.1v-55.8c0-4.5 3.6-8.1 8.1-8.1h40.9l52.3-35.9zm50.5 16.7c-3.5-2.9-8.6-2.4-11.5 1.1s-2.4 8.6 1.1 11.5c13.8 11.5 21.5 26.6 21.5 42.6s-7.6 31.1-21.5 42.6c-3.5 2.9-4 8-1.1 11.5 1.6 1.9 3.9 3 6.3 3 1.8 0 3.7-.6 5.2-1.9 17.7-14.6 27.4-34.2 27.4-55.1 0-21.1-9.7-40.6-27.4-55.3zm-11.1 25.6c-2.8-3.5-7.9-4-11.5-1.2-3.5 2.8-4.1 7.9-1.2 11.5 8.4 10.5 8.4 28.2 0 38.7-2.8 3.5-2.3 8.6 1.2 11.5 1.5 1.2 3.3 1.8 5.1 1.8 2.4 0 4.7-1 6.4-3 13.4-16.8 13.4-42.7 0-59.3z"
        className="st101"
      ></path>
      <path
        id="sound-on-hover"
        d="M161.7 78.2c2.5-1.7 5.7-1.9 8.4-.5s4.3 4.2 4.3 7.2v130.3c0 3-1.7 5.8-4.3 7.2-1.2.6-2.5.9-3.8.9-1.6 0-3.2-.5-4.6-1.4l-52.2-35.8h-41c-4.5 0-8.1-3.6-8.1-8.1v-55.8c0-4.5 3.6-8.1 8.1-8.1h40.9l52.3-35.9zm50.5 16.7c-3.5-2.9-8.6-2.4-11.5 1.1s-2.4 8.6 1.1 11.5c13.8 11.5 21.5 26.6 21.5 42.6s-7.6 31.1-21.5 42.6c-3.5 2.9-4 8-1.1 11.5 1.6 1.9 3.9 3 6.3 3 1.8 0 3.7-.6 5.2-1.9 17.7-14.6 27.4-34.2 27.4-55.1 0-21.1-9.7-40.6-27.4-55.3zm-11.1 25.6c-2.8-3.5-7.9-4-11.5-1.2-3.5 2.8-4.1 7.9-1.2 11.5 8.4 10.5 8.4 28.2 0 38.7-2.8 3.5-2.3 8.6 1.2 11.5 1.5 1.2 3.3 1.8 5.1 1.8 2.4 0 4.7-1 6.4-3 13.4-16.8 13.4-42.7 0-59.3z"
        className="st102"
      ></path>
      <path
        id="sound-off-idle"
        d="M174.5 84.8v66.6l-48.7-48.7 35.9-24.6c2.5-1.7 5.7-1.9 8.4-.5s4.4 4.2 4.4 7.2zm48.9 65.2c0 13-5.1 25.4-14.5 35.8l11.5 11.5c12.4-13.5 19.2-29.9 19.2-47.3 0-20.9-9.7-40.5-27.4-55.1-3.5-2.9-8.6-2.4-11.5 1.1s-2.4 8.6 1.1 11.5c14 11.4 21.6 26.5 21.6 42.5zm-33.3 16.9l11.7 11.7c12.7-16.6 12.5-41.9-.6-58.2-2.8-3.5-7.9-4-11.5-1.2-3.5 2.8-4.1 7.9-1.2 11.5 7.9 9.7 8.3 25.6 1.6 36.2zm-99.1-53H68.6c-4.5 0-8.1 3.6-8.1 8.1v55.8c0 4.5 3.6 8.1 8.1 8.1h40.9l52.2 35.8c1.4.9 3 1.4 4.6 1.4 1.3 0 2.6-.3 3.8-.9 2.7-1.4 4.3-4.2 4.3-7.2v-17.7L91 113.9zM79.2 79.1c3.2-3.2 8.3-3.2 11.5 0L221 209.4c3.2 3.2 3.2 8.3 0 11.5-1.6 1.6-3.7 2.4-5.8 2.4s-4.2-.8-5.8-2.4L79.2 90.6c-3.2-3.2-3.2-8.4 0-11.5z"
        className="st103"
      ></path>
      <path
        id="sound-off-hover"
        d="M174.5 84.8v66.6l-48.7-48.7 35.9-24.6c2.5-1.7 5.7-1.9 8.4-.5s4.4 4.2 4.4 7.2zm48.9 65.2c0 13-5.1 25.4-14.5 35.8l11.5 11.5c12.4-13.5 19.2-29.9 19.2-47.3 0-20.9-9.7-40.5-27.4-55.1-3.5-2.9-8.6-2.4-11.5 1.1s-2.4 8.6 1.1 11.5c14 11.4 21.6 26.5 21.6 42.5zm-33.3 16.9l11.7 11.7c12.7-16.6 12.5-41.9-.6-58.2-2.8-3.5-7.9-4-11.5-1.2-3.5 2.8-4.1 7.9-1.2 11.5 7.9 9.7 8.3 25.6 1.6 36.2zm-99.1-53H68.6c-4.5 0-8.1 3.6-8.1 8.1v55.8c0 4.5 3.6 8.1 8.1 8.1h40.9l52.2 35.8c1.4.9 3 1.4 4.6 1.4 1.3 0 2.6-.3 3.8-.9 2.7-1.4 4.3-4.2 4.3-7.2v-17.7L91 113.9zM79.2 79.1c3.2-3.2 8.3-3.2 11.5 0L221 209.4c3.2 3.2 3.2 8.3 0 11.5-1.6 1.6-3.7 2.4-5.8 2.4s-4.2-.8-5.8-2.4L79.2 90.6c-3.2-3.2-3.2-8.4 0-11.5z"
        className="st104"
      ></path>
    </svg>
  )
}

export default Icon
